var _div;
import cn from 'clsx';
import LockCircle from '@crehana/compass.icons.fill/LockCircle';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var SubMenuDesktopLink = function SubMenuDesktopLink(_ref) {
  var label = _ref.label,
    isLocked = _ref.isLocked,
    _ref$decorationType = _ref.decorationType,
    decorationType = _ref$decorationType === void 0 ? 'left-line' : _ref$decorationType,
    isSelectedURL = _ref.isSelectedURL,
    onClickItem = _ref.onClickItem;
  var isLeftLine = decorationType === 'left-line';
  return /*#__PURE__*/_jsx("li", {
    className: cn('tw-font-subtitle5', {
      'tw-ml-3.2 my-8 tw-mr-1.2': isLeftLine
    }),
    children: /*#__PURE__*/_jsxs("button", {
      type: "button",
      onClick: function onClick() {
        if (isLocked) return;
        onClickItem();
      },
      className: cn(isLocked ? 'tw-cursor-not-allowed' : 'hover:tw-text-primary-light-500 ', 'tw-flex tw-items-center tw-w-full tw-h-3.6 tw-px-1.2 tw-text-left tw-rounded-[5px] tw-relative tw-z-2', isSelectedURL ? 'tw-bg-neutral-dark-200 tw-text-primary-light-500' : 'tw-text-neutral-light-700 hover:tw-bg-neutral-light-200',
      // Dark theme
      'dark:tw-text-neutral-dark-400 dark:hover:tw-text-secondary-dark-300 dark:hover:tw-bg-neutral-dark-700'),
      children: [isLeftLine && (_div || (_div = /*#__PURE__*/_jsx("div", {
        className: "tw-absolute -tw-top-[2.8rem] -tw-left-1.2 tw-z-1 tw-w-[20px] tw-h-4.8 tw-bg-transparent tw-border-l-[2px] tw-border-b-[2px] tw-border-solid tw-rounded-[5px] dark:tw-border-elevation-dark-04 tw-border-neutral-light-300 tw-rounded-br-0 "
      }))), /*#__PURE__*/_jsx("p", {
        children: label
      }), isLocked && /*#__PURE__*/_jsx(LockCircle, {
        size: 20,
        className: cn('tw-ml-auto tw-text-neutral-dark-400', isSelectedURL && 'tw-text-primary-light-300')
      })]
    })
  });
};